import { Link } from "react-router-dom";
import * as Icons from "heroicons-react";
import Header from "../../Common/Header/Header";
import SideBar from "../../Common/SideBar/SideBar";
import { signInUser } from "../../Utility/Auth";
import { useSelector } from "react-redux";
import ReportSideBar from "../../Common/SideBar/ReportSideBar";
import DatePicker from "react-datepicker";
import { useEffect, useState } from "react";
import { format } from "date-fns";
import WareHouseDW from "../../Common/CustomSelect/WareHouseDW";
import { useWarehouseQuery } from "../../../services/warehouseApi";
import { useInvoiceWiseProfitQuery } from "../../../services/reportsApi";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const InvoiceWiseGrossProfitReport = () => {
  const auth = signInUser();
  const [warehouse, setWarehouse] = useState("allWh");

  const [startDate, setStartDate] = useState(format(new Date(), "MM-dd-yyyy"));
  const [endDate, setEndDate] = useState(format(new Date(), "MM-dd-yyyy"));
  const { aamarId, storeSettings } = auth;
  const lang = useSelector((state) => state.languageReducer);

  const {
    data: sale,
    isLoading,
    isError,
    error,
  } = useInvoiceWiseProfitQuery({
    startDate,
    endDate,
    warehouse,
    aamarId,
  });

  console.log("sale", sale);

  // fine warehouse Name
  const [whName, setWhName] = useState("All Warehouses");

  const { data: wh, refetch } = useWarehouseQuery(warehouse);

  // Call refetch only if user?.warehouse changes
  useEffect(() => {
    if (warehouse) {
      refetch();
    }
  }, [warehouse, refetch]);

  // Update warehouse name when data changes
  useEffect(() => {
    if (wh?.name) {
      setWhName(wh.name); // Directly set the name, no need for optional chaining here
    }
  }, [wh]);

// Export CSV
const handleExportCSV = () => {
  if (!sale?.length) {
    alert("No data available for export.");
    return;
  }

  const start = new Date(startDate).toLocaleString();
  const end = new Date(endDate).toLocaleString();
  const generatedOn = new Date().toLocaleString();
  const generatedBy = auth?.name || "Aamar Dokan";

  const warehouse = whName || "All Warehouses";
  const storeName = auth?.storeSettings?.storeName?.toUpperCase() || "Aamar Dokan";
  const reportTitle = "Invoice Wise Gross Profit Report";

  const headerInfo = [
    `,Store: ${storeName},,,,,,,,,,,,Warehouse: ${warehouse}`,
    `,Report: ${reportTitle},,,,,,,,,,,,Date Range: ${start} to ${end}`,
    `,Generated On: ${generatedOn},,,,,,,,,,,,Generated By: ${generatedBy}`,
    "",
    "",
  ];

  const csvTableHeader = [
    "S/N",
    "Invoice No",
    "Date",
    "warehouse",
    "Customer Name",
    "Phone",
    "Biller Name",
    "Total Sale Amount",
    "Total Qty",
    "TP",
    "MRP",
    "Gross Profit",
    "Profit %",
    "Discount",
    "Payment Method",
  ].join(",");

  let totalSaleAmount = 0;
  let totalTP = 0;
  let totalMRP = 0;
  let totalQty = 0;
  let totalGrossProfit = 0;
  let totalDiscount = 0;

  const csvRows = sale.map((item, index) => {
    const saleAmount = Number(item?.totalSaleAmount || 0);
    const tp = Number(item?.totalTP || 0);
    const mrp = Number(item?.totalMRP || 0);
    const qty = Number(item?.totalQty || 0);
    const grossProfit = Number(item?.grossProfit || 0);
    const discount = Number(item?.discount || 0);
    const profitPercent = item?.profitPercent || "0";

    totalSaleAmount += saleAmount;
    totalTP += tp;
    totalMRP += mrp;
    totalQty += qty;
    totalGrossProfit += grossProfit;
    totalDiscount += discount;

    return [
      index + 1,
      item?.invoiceId || "",
      new Date(item?.date).toLocaleDateString(),
      item?.customer || "Walkway Customer",
      item?.warehouse || "All Warehouses",
      item?.phone || "017 XX XXX XXX",
      item?.biller || auth?.name || "Biller",
      saleAmount,
      qty,
      tp,
      mrp,
      grossProfit,
      profitPercent,
      discount,
      item?.paymentMethod || "Cash",
    ].join(",");
  });

  const summaryLabelRow = [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "** TOTAL SUMMARY **",
  ].join(",");

  const summaryHeaderRow = [
    "",
    "",
    "",
    "",
    "",
    "",
    "Total Sale Amount",
    "Total Qty",
    "Total TP",
    "Total MRP",
    "Total Gross Profit",
    "Avg. Profit %",
    "Total Discount",
    "",
  ].join(",");

  const summaryDataRow = [
    "",
    "",
    "",
    "",
    "",
    "",
    totalSaleAmount,
    totalQty,
    totalTP,
    totalMRP,
    totalGrossProfit,
    (totalGrossProfit / totalSaleAmount * 100).toFixed(2) || "0",
    totalDiscount,
    "",
  ].join(",");

  const csvContent = [
    ...headerInfo,
    csvTableHeader,
    ...csvRows,
    "",
    "",
    summaryLabelRow,
    summaryHeaderRow,
    summaryDataRow,
  ].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "InvoiceWiseGrossProfitReport.csv";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};



  // export PDF
  const handleExportPDF = () => {
    const doc = new jsPDF("landscape");
    if (!sale?.length) {
      alert("No data available for export.");
      return;
    }

    // === Header Info ===
    const options = { month: "numeric", day: "numeric", year: "numeric" };
    const formattedStart = new Date(startDate).toLocaleDateString(
      "en-US",
      options
    );
    const formattedEnd = new Date(endDate).toLocaleDateString("en-US", options);
    const reportGeneratedAt = new Date().toLocaleString();
    const storeName =
      auth?.storeSettings?.storeName?.toUpperCase() || "Aamar Dokan";
    const warehouseName = whName;
    const reportName = "Invoice Wise Gross Profit Report";

    // === Title ===
    doc.setFontSize(16);
    doc.text(storeName, 140, 15, { align: "center" });

    doc.setFontSize(12);
    doc.text(reportName, 140, 22, { align: "center" });

    // === Info ===
    doc.setFontSize(10);
    doc.text(`Store: ${storeName}`, 14, 28);
    doc.text(`Warehouse: ${warehouseName}`, 14, 33);
    doc.text(`Date: ${formattedStart} - ${formattedEnd}`, 14, 39);
    doc.text(`Generated By: ${auth?.name}`, 280, 28, { align: "right" });
    doc.text(`${reportGeneratedAt}`, 280, 33, { align: "right" });

    // === Table Headers ===
    const headers = [
      [
        "S/N",
        "Invoice No",
        "Date",
        "Warehouse",
        "Customer Name",
        "Phone",
        "Biller Name",
        "Total Sale Amount",
        "Total Qty",
        "TP",
        "MRP",
        "Gross Profit",
        "Profit %",
        "Discount",
        "Payment Method",
      ],
    ];

    // === Table Body ===
    const body = sale.map((item, index) => [
      index + 1,
      item.invoiceId,
      new Date(item.date).toLocaleDateString(),
      item.warehouse || "All Warehouses",
      item.customer || "Walkway Customer",
      item.phone || "017 XX XXX XXX",
      item.billerName || "N/A",
      item.totalSaleAmount,
      item.totalQty,
      item.totalTP,
      item.totalMRP,
      item.grossProfit,
      item.profitPercent + " %",
      item.discount,
      item.paymentMethod,
    ]);

    // === Table Generation ===
    autoTable(doc, {
      head: headers,
      body: body,
      startY: 45,
      theme: "grid",
      styles: {
        fontSize: 7,
        halign: "center",
      },
      headStyles: {
        fillColor: [242, 101, 45],
        textColor: [255, 255, 255],
        fontStyle: "bold",
      },
    });

     // === Summary Section ===
  const finalY = doc.lastAutoTable.finalY + 10;
  const boxWidth = 110;
  const pageWidth = doc.internal.pageSize.getWidth();
  const boxX = pageWidth - boxWidth - 15;
  const boxY = finalY;

  // === Total Calculation ===
  const totalSaleAmount = sumField(sale, "totalSaleAmount");
  const totalTP = sumField(sale, "totalTP");
  const totalMRP = sumField(sale, "totalMRP");
  const totalQty = sumField(sale, "totalQty");
  const totalProfit = sumField(sale, "grossProfit");
  const totalDiscount = sumField(sale, "discount");

  const avgProfitPercent =
    totalSaleAmount > 0 ? ((totalProfit / totalSaleAmount) * 100).toFixed(2) + " %" : "0 %";

  // === Draw Summary Box ===
  doc.setLineDashPattern([1, 1], 0);
  doc.rect(boxX, boxY, boxWidth, 60);
  doc.setLineDashPattern([], 0);

  const labelX = boxX + 5;
  const valueX = boxX + boxWidth - 5;
  let y = boxY + 10;

  doc.setFontSize(9);

  doc.text("Total Sale Amount:", labelX, y);
  doc.text(`${totalSaleAmount}`, valueX, y, { align: "right" });

  y += 6;
  doc.text("Total Qty:", labelX, y);
  doc.text(`${totalQty}`, valueX, y, { align: "right" });
  y += 6;
  doc.text("Total TP:", labelX, y);
  doc.text(`${totalTP}`, valueX, y, { align: "right" });

  y += 6;
  doc.text("Total MRP:", labelX, y);
  doc.text(`${totalMRP}`, valueX, y, { align: "right" });

  y += 6;
  doc.text("Gross Profit:", labelX, y);
  doc.text(`${totalProfit}`, valueX, y, { align: "right" });

  y += 6;
  doc.text("Total Discount:", labelX, y);
  doc.text(`${totalDiscount}`, valueX, y, { align: "right" });

  y += 6;
  doc.text("Avg. Profit %:", labelX, y);
  doc.text(`${avgProfitPercent}`, valueX, y, { align: "right" });

    // === Save PDF ===
    doc.save("Invoice_Wise_Gross_Profit_Report.pdf");
  };

  // Utility to sum fields
  const sumField = (array, field) => {
    return array
      .reduce((sum, item) => sum + (parseFloat(item[field]) || 0), 0)
      .toFixed(2);
  };

  //warehouse
  const handleOnchangeWareHouseFrom = (e) => {
    if (e.option !== "no-warehouse") {
      setWarehouse(e.option);
    } else {
      setWarehouse("allWh");
    }
  };

  return (
    <div>
      <div>
        <h2 className="mb-3">
          <Icons.ShoppingCartOutline size={35} /> Invoice Wise Gross Profit
          Report
        </h2>
      </div>

      <div
        className="mt-3 w-40 p-3"
        style={{ backgroundColor: "#f1f3f5", borderRadius: "8px" }}
      >
        <div className=" d-flex mt-2 mb-2 align-items-center justify-content-center gap-2">
          <DatePicker
            selected={new Date(startDate)}
            className="form-control w-100"
            onChange={(date) =>
              setStartDate(format(new Date(date), "MM-dd-yyyy"))
            }
          />
          <DatePicker
            selected={new Date(endDate)}
            className="form-control me-4"
            onChange={(date) =>
              setEndDate(format(new Date(date), "MM-dd-yyyy"))
            }
          />
        </div>

        <div className="">
          {auth?.type === "admin" && (
            <div className="my-3">
              <WareHouseDW
                id="warehouse"
                name="warehouse"
                handleOnChange={handleOnchangeWareHouseFrom}
                className="form-control"
              />
            </div>
          )}
        </div>

        <div className="d-flex gap-3 justify-content-center align-items-center text-center">
          {/* Download CSV Button */}
          <button
            className="btn btn-dark w-100 mt-3"
            style={{ borderRadius: "5px" }}
            onClick={handleExportCSV}
          >
            <Icons.DownloadOutline size={22} /> Download CSV
          </button>

          {/* Download PDF Button */}
          <button
            className="btn btn-dark w-100 mt-3"
            style={{ borderRadius: "5px" }}
            onClick={handleExportPDF}
          >
            <Icons.DocumentOutline size={22} /> Download PDF
          </button>
        </div>
      </div>
    </div>
  );
};

export default InvoiceWiseGrossProfitReport;
